import React from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

import * as APPDATA from '@/constants/pcConstAppData';
import {gapFixerClass} from '@/libs/styleHelper';

import IntlMessage from '../intlMessage/IntlMessage';

import './MembraneCutOffSelection.less';

export const membraneCutOffOptions = [
  {
    value: 3,
    label: '3',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 100,
    label: '100',
  },
  {
    value: 300,
    label: '300',
  },
];

function MembraneCutOffSelection({value, onChangeMembraneCutOff, disabled}) {
  return (
    <div
      className={`membrane-cutoff-size-selection ${gapFixerClass()} div-3col center`}
      disabled={disabled}
    >
      <p>
        <IntlMessage id="cleaning.setup.mwco" />
      </p>
      <Select
        id={APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}
        name="form-field-name"
        options={membraneCutOffOptions}
        className="selectField membraneCutOffSizeSelect"
        value={value}
        onChange={onChangeMembraneCutOff}
        clearable={false}
        searchable={false}
        placeholder=""
        // set selector to up
        menuContainerStyle={{
          top: 'auto',
          bottom: '100%',
          width: '100px',
          left: '-5px',
          maxHeight: '300px',
        }}
        disabled={disabled}
      />
      <p>{APPDATA.UNIT.kda}</p>
    </div>
  );
}

MembraneCutOffSelection.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChangeMembraneCutOff: PropTypes.func,
};

MembraneCutOffSelection.defaultProps = {
  value: null,
  disabled: false,
  onChangeMembraneCutOff: () => {},
};

export default MembraneCutOffSelection;
